import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shijian",
  "use": "icon-shijian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shijian\"><defs><style></style></defs><path d=\"M565.9 520.4V320.9c0-28.7-23.2-51.9-51.9-51.9s-51.9 23.2-51.9 51.9v259.4L686.8 710c24.9 14.2 56.6 5.5 70.7-19.5 14-24.7 5.6-56-18.9-70.4l-172.7-99.7zm-54.6 408c-229.2 0-415.1-185.8-415.1-415.1S282.1 98.2 511.3 98.2 926.4 284 926.4 513.3 740.6 928.4 511.3 928.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol